@if (isPresentation()) {
  <div class="cap-alert-preview cap-alert-preview--presentation">
    <span class="cap-alert-preview__icon-tile">
      <mat-icon svgIcon="presentations" aria-hidden="true" />
    </span>
    <p class="cap-alert-preview__name">{{ presentationName() }}</p>
    <p class="cap-alert-preview__notice">
      Preview not available for presentations
    </p>
    <p class="cap-alert-preview__line">
      Alerts will play “{{ presentationName() }}”. Presentations can’t be
      previewed here.
    </p>
  </div>
} @else {
  <div
    #box
    class="cap-alert-preview cap-alert-preview--template"
    [style.aspect-ratio]="aspectRatio()"
  >
    @if (showsTemplate()) {
      <iframe
        #frame
        class="cap-alert-preview__frame"
        scrolling="no"
        tabindex="-1"
        [title]="label()"
        [src]="templateUrl()"
        [style.width.px]="contentWidth()"
        [style.height.px]="contentHeight()"
        [style.transform]="'scale(' + scale() + ')'"
        (load)="onLoad()"
      ></iframe>
    } @else {
      <span
        class="cap-alert-preview__placeholder"
        role="img"
        [attr.aria-label]="label()"
      ></span>
    }
  </div>
}
